/**
 * Returns a month display string (e.g. "January 2020").
 * @param date - Any date within the month.
 * @returns The month display string (e.g. "January 2020")
 */
export function getMonthString(date: Date): string {
  return date.toLocaleString('default', { month: 'long' }) + ' ' + date.getFullYear()
}

export function getStartMonth(): Date {
  const result = new Date()
  result.setDate(1)
  result.setHours(0, 0, 0, 0)
  return result
}
export function getOrdinalSuffix(day: number): string {
  if (day > 3 && day < 21) return 'th' // Covers 4th to 20th
  switch (day % 10) {
    case 1:
      return 'st'
    case 2:
      return 'nd'
    case 3:
      return 'rd'
    default:
      return 'th'
  }
}

export function formatCustomDate(date: Date): string {
  const dayName = date.toLocaleString('en-US', { weekday: 'long' })
  const monthName = date.toLocaleString('en-US', { month: 'long' })
  const dayOfMonth = date.getDate()
  const ordinalDay = dayOfMonth + getOrdinalSuffix(dayOfMonth)

  return `${dayName} ${ordinalDay} of ${monthName}`
}
